<template>
  <v-card class="course-dialog">

    <v-card-text class="course-dialog__body">
      
      <v-btn icon aria-label="Close" class="course-dialog__close" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div v-if="loading && !course" class="course-dialog__loading">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <CourseDetailPage
        v-if="course"
        embedded
        :course="course"
        @add-fav="addFav"
        @del-fav="delFav"
      />
    </v-card-text>

    <v-snackbar v-model="snackbar_show" :color="snackbar_color" top timeout="2000">
      <v-icon>{{ snackbar_icon }}</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-card>
</template>

<script>
import CourseDetailPage from "@/components/v2/CourseDetailPage.vue";
export default {
  name: "CourseView",
  components: {CourseDetailPage},
  props:[

    "selectedCourse"
  ],
  data: () => ( {
    course: null,
    loading: false,
    lang: null,
    // Snackbar
    snackbar_show: false,
    snackbar_color: null,
    snackbar_text: null,
    snackbar_icon: null,
    // Used to build the course urls
    userType: null,
    dialog: false,
    // env
    VUE_APP_API_ENDPOINT: process.env.VUE_APP_API_ENDPOINT,
  }),

  watch: {
    selectedCourse: {
      immediate: true,
      handler(course) {
        this.loadCourse(course)
      },
    },
  },

  async mounted() {
    /*
    try {
      await this.getData();
    } catch (error) {
      if (error.message.includes("Authentication failed")) {
        this.$router.push("/auth-error");
      }
    }
    */
    this.userType = this.$route.path.match(/\/app\/(.+?)\//)[1];
  },

  methods: {
    async loadCourse(source) {
      const id = source && source.course_id
      if (!id) {
        this.course = null
        this.loading = false
        return
      }
      this.loading = true
      this.course = source
      try {
        let response = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "v2/common/courses/" + id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        )
        response = await response.json()
        if (!this.selectedCourse || this.selectedCourse.course_id !== id) return
        if (response.success && response.result) {
          const course = response.result
          if (course.fav_id == null && source.fav_id != null) {
            course.fav_id = source.fav_id
          }
          this.course = course
        }
      } catch (error) {
        if (this.selectedCourse && this.selectedCourse.course_id === id) {
          this.course = source
        }
      } finally {
        if (!this.selectedCourse || this.selectedCourse.course_id === id) {
          this.loading = false
        }
      }
    },
    // Insert a course in favourites
    async addFav() {
      let responseInsert;
      try {
        responseInsert = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "common/add-fav-courses",
          {
            method: "POST",
            body: JSON.stringify({
              course_id: this.selectedCourse.course_id,
            }),
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        responseInsert = await responseInsert.json();
        if (responseInsert.success) {
          this.snackbar_color = "success";
          this.snackbar_text = "Success: course added to favorites";
          this.snackbar_icon = "mdi-success-circle";
          this.snackbar_show = true;

          this.$set(this.course, "fav_id", -1);
          this.selectedCourse.fav_id = -1;

          this.$emit('addToList',this.selectedCourse);
          setTimeout(()=>{

            this.snackbar_show = false;
            //this.$emit('close');
          },1500);

        } else {
          throw new Error(responseInsert.message);
        }
      } catch (error) {
        if (error.message === "alreadySaved") {
          // Warning message
          this.snackbar_color = "orange";
          this.snackbar_text = "The course was already saved as favorite";
          this.snackbar_icon = "mdi-alert-outline";
        } else {
          // Error message
          this.snackbar_color = "error";
          this.snackbar_text = error.message;
          this.snackbar_icon = "mdi-alert-circle";
        }
        this.snackbar_show = true;
      }
    },
    // Delete a course in favourites
    async delFav() {
      console.log(JSON.stringify(this.selectedCourse))
      let responseDelete;
      try {
        responseDelete = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "common/delete-fav-courses",
          {
            method: "POST",
            body: JSON.stringify({
              course_id: this.selectedCourse.course_id,
            }),
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        responseDelete = await responseDelete.json();
        if (responseDelete.success) {
          this.snackbar_color = "success";
          this.snackbar_text = "Success: course removed from favorites";
          this.snackbar_icon = "mdi-success-circle";
          this.snackbar_show = true;

          this.$set(this.course, "fav_id", null);
          this.selectedCourse.fav_id = null;
          this.$emit('removeFromList',this.selectedCourse.course_id);

          setTimeout(()=>{
            this.snackbar_show = false;
            //this.$emit('close');
          },1500);
        } else {
          throw new Error(responseDelete.message);
        }
      } catch (error) {
        // Error message
        this.snackbar_color = "error";
        this.snackbar_text = error.message;
        this.snackbar_icon = "mdi-alert-circle";
        this.snackbar_show = true;
      }


    },
  }
}

</script>

<style scoped>
.course-dialog__bar {
  display: flex;
  justify-content: flex-end;
  padding: 4px 8px 0;
}

.course-dialog {
  position: relative;
}

.course-dialog__body {
  background: #f8fafc;
  padding-top: 0 !important;
}

.course-dialog__close {
  position: absolute;
  top: 12px;
  right: 25px;
  z-index: 2;
  margin: 0;
  background: #f8fafc;
}


.course-dialog__loading {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}
</style>
